export default "__VITE_ASSET__Cw8LheA5__"